import {
    PrinterRowData,
    PrinterSettingConfig,
    PrinterSettingDataBlob,
    PrinterSettingUserIds,
} from "../types";

const APP_NAME_FIELD_DEFAULT = "applicationDesignation";

/**
 * Builds the body sent to the default (non-customSave) printer-settings save
 * endpoint. Pure: same inputs → same object, no side effects — extracted from
 * useSavePrinterSetting so the payload shape can be unit-tested without mocks.
 *
 * `uuidUser` / `operatorId` are included unless explicitly disabled via
 * `config.features.includeUuidUser` / `includeOperatorId === false`.
 */
export function buildSavePayload(
    config: PrinterSettingConfig,
    rowData: PrinterRowData,
    dataBlob: PrinterSettingDataBlob,
    userIds: PrinterSettingUserIds
): Record<string, unknown> {
    const features = config.features ?? {};
    const appNameField = config.appNameField ?? APP_NAME_FIELD_DEFAULT;

    const savedData: Record<string, unknown> = {
        userId: userIds.userId,
        shopId: userIds.shopId,
        franchiseId: userIds.franchiseId,
        appName: [rowData[appNameField]],
        appId: config.appId,
        appId_children: rowData.appId,
        peripheralId: rowData.peripheralId,
        data: dataBlob,
    };

    if (features.includeUuidUser !== false) {
        savedData.uuidUser = userIds.uuidUser;
    }
    if (features.includeOperatorId !== false) {
        savedData.operatorId = userIds.operatorId;
    }

    return savedData;
}
